// extracted by mini-css-extract-plugin
export var box = "_2e-1";
export var checkboxRow = "_2e-8";
export var checked = "_2e-2";
export var descriptionSpacer = "_2e-a";
export var disabled = "_2e-3";
export var icon = "_2e-6";
export var input = "_2e-0";
export var labelSpacer = "_2e-9";
export var medium = "_2e-5";
export var small = "_2e-4";
export var text = "_2e-7";